import { memo, FC } from 'react';
import { Box, ListItem, UnorderedList } from '@chakra-ui/react';

import { Contract } from 'types/contract';
import { AddIconButton } from 'components/atoms/AddIconButton';
import { ContractListHeader } from './ContractListHeader';
import { ContractListItem } from './ContractListItem';
import { ContractListSkeleton } from './CustomerListSkeleton';

type Props = {
  loading: boolean;
  contracts: Contract[];
  handleContractClick: (contract: Contract) => void;
  handleNewContractClick: () => void;
};

export const ContractListView: FC<Props> = memo(
  ({ loading, contracts, handleContractClick, handleNewContractClick }) => {
    if (loading) {
      return <ContractListSkeleton />;
    }

    return (
      <Box m="20px 0 0 0px">
        {/* 契約一覧のヘッダ */}
        <ContractListHeader />
        {/* 契約一覧 */}
        <UnorderedList h="400px" overflowY="scroll">
          {contracts.map((item) => (
            <ListItem key={item.id} listStyleType="none">
              <ContractListItem
                item={item}
                handleContractClick={() => handleContractClick(item)}
              />
            </ListItem>
          ))}
        </UnorderedList>
        {/* 契約一覧のフッタ */}
        <Box mt="10px">
          <AddIconButton
            label="契約メニューを追加"
            onClick={handleNewContractClick}
          />
        </Box>
      </Box>
    );
  },
);
